import VueRouter from "vue-router";
import Vue from "vue";
import { staticRouter, errorRouter } from "./routes";
import NProgress from "@/config/nprogress";
import store from "@/store";

Vue.use(VueRouter);
let originPush = VueRouter.prototype.push;
let originReplace = VueRouter.prototype.replace;
VueRouter.prototype.push = function (location, resolve, reject) {
    if (resolve && reject) {
        originPush.call(this, location, resolve, reject);
    }
    else {
        originPush.call(this, location, () => { }, () => { });
    }
}
VueRouter.prototype.replace = function (location, resolve, reject) {
    if (resolve && reject) {
        originReplace.call(this, location, resolve, reject);
    } else {
        originReplace.call(
            this,
            location,
            () => { },
            () => { }
        );
    }
};

let router = new VueRouter({
    routes: [...staticRouter, ...errorRouter],
    scrollBehavior(to, from, savedPosition) {
        return { y: 0 };
    },
});
router.beforeEach(async (to, from, next) => {
    NProgress.start()
    let token = store.getters.token;
    if (token) {
        if (to.path === '/login') {
            NProgress.done()
            next('/home')
        } else {
            next()
        }
    } else {
        if (to.path !== '/login') {
            NProgress.done()
            next('/login')
        } else {
            next()
        }
    }
})
router.afterEach((to, from, next) => {
    // 每次路由变化时设置页面标题
    document.title = to.meta.title || '遇龙河景区';
    NProgress.done()
})
export default router